import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const raw = localStorage.getItem("token");
    let token = null;
    if (raw) {
      try {
        token = JSON.parse(raw);
      } catch {
        token = raw;
      }
    }
    const url = getBackendUrl();
    const options = {
      transports: ["websocket", "polling", "flashsocket"],
    };
    if (token != null) {
      options.query = { token };
    }
    return openSocket(url, options);
}

export default connectToSocket;